import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const TravelSol = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div>
			<Navbar />
			<div
				style={{
					backgroundImage:
						"url('https://aryaaviation.com/assets/images/travel-api-integration.jpg')",
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					Travel API Integration
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					Travel API Integration
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30 }}>
					Travel API Solution
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={12}>
							<p>
								APIs authorize the interaction between the data, applications
								and devices. It delivers data between devices and programs. It
								helps the business to run easily and benefit the customers by
								connecting to server. In this modern world, the internet has
								become a fundamental piece of our life. This faith in cell
								phones expands accomplished application improvement.
							</p>
							<br />
							<p>
								Application Program Interface or API for travel entrance
								constructs travel guides, courses, and other fundamental things
								that can enable the traveller to recognize a specific spot. On
								certain events, it may be utilized to find excursion spots,
								finding accommodation, guide, celebrated milestones, verifiable
								visiting spots, lodgings, and eateries. Along these lines,
								travellers can discover just by tapping their gadgets. The
								programming interface is a remarkable method of pulling up
								spreads in a short timeframe. In the Travel Industry to provide
								real-time bookings and inventory fetching Travel Agencies can
								integrate Airline or Flight Booking API, Hotel Booking API, Bus
								API, Car Booking API etc.
							</p>
							<br />
							<p>
								A Travel Web Portal is not complete unless it has the
								integration of Travel APIs Flight API, Hotel API, Bus API, Car
								API etc. Online Flight booking on our own website made it very
								easy and flexible with Flight API Integration in your Flight
								Booking Website.
							</p>
						</Grid>
					</Grid>
				</Container>
			</div>
			<div style={{ padding: 10 }}>
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={8}>
							<p>
								APIs authorize the interaction between the data, applications
								and devices. It delivers data between devices and programs. It
								helps the business to run easily and benefit the customers by
								connecting to server. In this modern world, the internet has
								become a fundamental piece of our life. This faith in cell
								phones expands accomplished application improvement.
							</p>
							<br />
							<p>
								Application Program Interface or API for travel entrance
								constructs travel guides, courses, and other fundamental things
								that can enable the traveller to recognize a specific spot. On
								certain events, it may be utilized to find excursion spots,
								finding accommodation, guide, celebrated milestones, verifiable
								visiting spots, lodgings, and eateries. Along these lines,
								travellers can discover just by tapping their gadgets. The
								programming interface is a remarkable method of pulling up
								spreads in a short timeframe. In the Travel Industry to provide
								real-time bookings and inventory fetching Travel Agencies can
								integrate Airline or Flight Booking API, Hotel Booking API, Bus
								API, Car Booking API etc.
							</p>
							<br />
							<p>
								A Travel Web Portal is not complete unless it has the
								integration of Travel APIs Flight API, Hotel API, Bus API, Car
								API etc. Online Flight booking on our own website made it very
								easy and flexible with Flight API Integration in your Flight
								Booking Website.
							</p>
						</Grid>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/trvl-api-intrge-02.jpg' />
						</Grid>
					</Grid>
				</Container>
			</div>
			<div style={{ background: '#0a74c0', padding: 13 }}>
				<Container>
					<p style={{ color: 'white', fontSize: 14 }}>
						How does API Integration help to improve the growth of your
						business?
					</p>
				</Container>
			</div>

			<Container style={{ background: '#eaeaea', marginTop: 20, padding: 20 }}>
				<p style={{ fontSize: 14, fontWeight: 'bold' }}>
					Features of B2C Travel Portal:-
				</p>
			</Container>
			<Container style={{ marginTop: 10 }}>
				<Grid container>
					<Grid item xs={12}>
						{step.map((d) => {
							return <p style={{ marginTop: 5 }}>{d}</p>;
						})}
					</Grid>
				</Grid>
			</Container>
			<Divider />
			<Container>
				<div style={{ padding: 10 }}>
					<Container style={{ marginTop: 20 }}>
						<Grid container spacing={4}>
							<Grid item xs={4}>
								<img src='https://aryaaviation.com/assets/images/travel-api-intregi.jpg' />
							</Grid>
							<Grid item xs={8}>
								<p>
									An Online Travel Portal is not good unless it has the
									integration of Flight Booking APIs. The Flight Booking System
									is a base where the flight tickets reservation is available
									for passengers who want to process the booking through the
									web/app. Our Flight API also allows Travel Agents to have
									their own B2B Booking System. We have served several clients
									and have developed the best portals using our flight API. Our
									Flight Booking API is available for B2B as well as for B2C
									portal.
								</p>
								<br />
								<p>
									Hotel Bookings can be easily done with an efficient way to
									build a Hotel Booking Websites. By Integrating Hotel API with
									the web Portal, you can browse a large number of Hotel offers,
									book Room, cancel Room, generate reports for booking and
									cancellation, etc. very easily and efficiently.
								</p>
								<br />
								<p>
									Hotel APIs provides comprehensive descriptions including room
									types, images, and facilities, of over 7,00,000+ properties
									worldwide. As one of the trusted API providers globally, we
									are specialized in Hotel API Integration. All our services are
									integrated, tested and maintained by an experienced team of
									professionals.
								</p>
								<br />
								<p>
									Arya Aviation provides Bus/Car APIs for the easy bus/car
									bookings. This portal will also offer bus & car rentals
									advance bookings to those travellers who plan their trip to
									visit ‘n’ number of destinations.
								</p>
							</Grid>
						</Grid>
					</Container>
				</div>
			</Container>
			<Footer />
		</div>
	);
};

export default TravelSol;
